import { render, staticRenderFns } from "./editThemeContent.vue?vue&type=template&id=2df3e340&lang=pug"
import script from "./editThemeContent.vue?vue&type=script&lang=js"
export * from "./editThemeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports